import MedicosList from '../layout/pages/MedicosList.vue'
import { createStore } from 'vuex'

export const dataAso = createStore({
  state: () => {
    return {
      componentActive: MedicosList,
      pageTitle: 'Médicos',
      pageSubTitle: 'Gerencie sua equipe com facilidade',

      docs: [],
      cities: [],
      pacientes: [],
      schedules: [],
      formConsulta: {
        medico_id: null,
        paciente_id: null,
        data: null
      },
      formDoctor: {
        nome: null,
        especialidade: null,
        cidade_id: null
      },
    }
  },
  getters: {
    getActiveComponent: (state) => state.componentActive,
    getTitle: (state) => state.pageTitle,
    getPageSubTitle: (state) => state.pageSubTitle,
    getDocs: (state) => state.docs,
    getCities: (state) => state.cities,
    getPacientes: (state) => state.pacientes,
    getSchedules: (state) => state.schedules,
  },
  mutations: {
    RESET_FORM(state) {
      state.formConsulta.medico_id = undefined
      state.formConsulta.paciente_id = undefined
      state.formConsulta.data = undefined

      state.formDoctor.nome = undefined
      state.formDoctor.especialidade = undefined
      state.formDoctor.cidade_id = undefined
    },
    SET_COMPONENT_ACTIVE(state, value) {
      state.componentActive = value
    },
    SET_ALL_DOCS(state, value) {
      state.docs = []
      state.docs = value
    },
    SET_ALL_CITIES(state, value) {
      state.cities = []
      state.cities = value
    },
    SET_ALL_PACIENTES(state, value) {
      state.pacientes = []
      state.pacientes = value
    },
    SET_ALL_SCHEDULES(state, value) {
      state.schedules = []
      state.schedules = value
    },
    SET_PAGE_TITLE(state, value) {
      state.pageTitle = value
    },
    SET_PAGE_SUB_TITLE(state, value) {
      state.pageSubTitle = value
    }
  },
  actions: {
    setComponentActive({ commit }, value) {
      commit('SET_COMPONENT_ACTIVE', value)
    },
    resetForm({ commit }) {
      commit('RESET_FORM')
    },
    setAllDocs({ commit }, val) {
      commit('SET_ALL_DOCS', val)
    },
    setAllCities({ commit }, val) {
      commit('SET_ALL_CITIES', val)
    },
    setAllPacientes({ commit }, val) {
      commit('SET_ALL_PACIENTES', val)
    },
    setAllSchedules({ commit }, val) {
      commit('SET_ALL_SCHEDULES', val)
    },
    setPageTitle({ commit }, value) {
      commit('SET_PAGE_TITLE', value)
    },
    setPageSubTitle({ commit }, value) {
      commit('SET_PAGE_SUB_TITLE', value)
    },
  }
})
